import { render, staticRenderFns } from "./Importer.vue?vue&type=template&id=bb0f3234&scoped=true&"
import script from "./Importer.vue?vue&type=script&lang=js&"
export * from "./Importer.vue?vue&type=script&lang=js&"
import style0 from "./Importer.vue?vue&type=style&index=0&id=bb0f3234&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0f3234",
  null
  
)

export default component.exports